import Stage from '__core/shared/model/stage/Stage';
import Workflow from '__core/shared/model/workflow/Workflow';
import { WorkflowType } from '__core/shared/model/workflow/Workflow.enum';
import stWorkflowDelete from './workflowDelete.component';
import workflowEditController from './workflowEdit.controller';
import workflowEditService from './workflowEdit.service';
import workflowsController from './workflows.controller';
import stWorkflowsList from './workflowsList.component';

export default angular
  .module('st.Workflow', ['st.Core', 'angular-cache'])
  .factory('Workflow', () => Workflow)
  .factory('WorkflowType', () => WorkflowType)
  .factory('WorkflowStage', () => Stage)
  .service('workflowEditService', workflowEditService)
  .component('stWorkflowDelete', stWorkflowDelete)
  .controller('workflowEditController', workflowEditController)
  .controller('workflowsController', workflowsController)
  .component('stWorkflowsList', stWorkflowsList)
  .service('workflowService', (Workflow, dataService) => ({
    createWorkflow: (doc) => dataService.createDocument(Workflow, doc),
    readWorkflow: (doc) => dataService.readDocument(Workflow, doc),
    updateWorkflow: (doc) => dataService.updateDocument(Workflow, doc),
    deleteWorkflow: (doc) => dataService.deleteDocument(Workflow, doc)
  }))
  .service(
    'workflowsService',
    ($q, $http, $rootScope, CacheFactory, dataService, Workflow, WORKFLOW) => {
      let cache;
      if (!CacheFactory.get(WORKFLOW.CACHE.NAME)) {
        cache = CacheFactory(WORKFLOW.CACHE.NAME, WORKFLOW.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount?.id,
          idOrganization: $rootScope.CurrentOrganization?.id,
          type: requestName || WORKFLOW.CACHE.NAME,
          params
        });
      return {
        clearCache: () => cache.removeAll(),
        getAvailable: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getAvailable'),
            params?.ignoreCache === true,
            Workflow.build,
            $http.get,
            WORKFLOW.API.AVAILABLE,
            { params }
          ),
        getSpecific: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getSpecific'),
            params?.ignoreCache === true,
            Workflow.build,
            $http.post,
            WORKFLOW.API.SPECIFIC,
            { params }
          ),
        getParent: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getParent'),
            params?.ignoreCache === true,
            null,
            $http.get,
            WORKFLOW.API.PARENT,
            { params }
          ),
        deleteWorkflows: (params) =>
          dataService.apiRequest(
            null,
            null,
            true,
            Workflow.build,
            $http.delete,
            WORKFLOW.API.DELETE,
            { params }
          )
      };
    }
  )
  .constant('WORKFLOW', {
    API: {
      AVAILABLE: '/api/v1/workflows/available/',
      PARENT: '/api/v1/workflows/parent/',
      SPECIFIC: '/api/v1/workflows/specific/',
      DELETE: '/api/v1/workflows/delete/'
    },
    UI: {
      EDITOR_HEADER_HEIGHT: 185,
      SINGLE_AUTOMATION_HEIGHT: 49
    },
    CACHE: {
      NAME: 'workflowsCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
